import { AnchorButton, Button, Card, Tooltip } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

export type TProps = {
  to: LinkProps['to'];
  title: string;
  conditions?: string[];
  additionalActions?: string[];
  disableTo: boolean;
  showEditButton?: boolean;
  showDeleteButton?: boolean;
  onDelete?: () => void;
};

const TargetingAutomationCard: FC<TProps> = (props) => {
  const {
    to,
    title,
    conditions,
    additionalActions,
    disableTo,
    showEditButton = true,
    showDeleteButton = false,
    onDelete,
  } = props;

  return (
    <Card sizeVariant="sm">
      <Card.Body className="space-y-1.5">
        <div className="flex justify-between">
          <p>{title}</p>

          {showEditButton && (
            <Tooltip
              enabled={disableTo}
              tooltipContent="Please save or discard your current changes before editing this automation"
            >
              <AnchorButton
                as={Link}
                to={to}
                className="-m-2"
                colour="black"
                variant="ghost"
                size="sm"
                aria-label={`Edit ${title} automation`}
                disabled={disableTo}
              >
                <UntitledIcon name="edit-01.3" className="size-4" />
              </AnchorButton>
            </Tooltip>
          )}

          {showDeleteButton && (
            <Button
              className="-m-2"
              colour="grey"
              variant="ghost"
              size="xs"
              aria-label={`Delete ${title} automation`}
              onClick={() => onDelete?.()}
            >
              <UntitledIcon name="x-close" className="h-3 w-3" />
            </Button>
          )}
        </div>

        {conditions && conditions.length > 0 && (
          <div>
            <p className="supporting-body text-gray-500">Only if:</p>
            <ul className="supporting-body text-gray-500 mt-1">
              {conditions.map((condition, index) => (
                <li key={`${condition}-${index}`}>{condition}</li>
              ))}
            </ul>
          </div>
        )}

        {additionalActions && additionalActions.length > 0 && (
          <div>
            <p className="supporting-body text-gray-500">Additional actions:</p>
            <ul className="supporting-body text-gray-500 mt-1">
              {additionalActions.map((action, index) => (
                <li key={`${action}-${index}`}>{action}</li>
              ))}
            </ul>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default TargetingAutomationCard;
